import { NavLink, useLocation } from "react-router-dom"; // import Link in addition to other Components
import { useState } from 'react';
import "./navbar.css";
import logo from '../../assets/polyverge-logo.png';

// import logo from "../logo.svg";

const Navbar = () => {
  let location = useLocation();  
  const addSubNav = () =>{
    // if (location.pathname !== '/'){
    return(
      <>
      {/* <NavLink className="nav-links" to="/clients">CLient Work</NavLink> */}
      <NavLink className="nav-links" to="/videopage">What I Do</NavLink>
      <NavLink 
        className="nav-links" 
        to="https://www.youtube.com/@Polyverge" 
        target={"_blank"} 
        rel="noopener noreferrer">Films And Series
      </NavLink>
      <NavLink className="nav-links" to="/novels">Illustrated Novels</NavLink>
      <NavLink className="nav-links" to="/illustrations">Art</NavLink>
      </>
    );
    // }

  }
  return (
    <>
      <nav className="navigation">
        <div className="left">
        <NavLink id="logo" to="/"> <img src={logo} className="" alt="logo"/> </NavLink>
        </div>
        <div className="right">
          {addSubNav()}
          <NavLink className="nav-links" to="/newsletter">Newsletter</NavLink>
          <NavLink className="nav-links nav-cta" to="/serviceinquiry">Work With Me</NavLink>

        </div>
      </nav>
    </>
  );
};

export default Navbar;
